import { useEffect } from 'react';

import type React from 'react';

import { setClass } from '../../helpers/utils';
import { Close } from '../Icons/Close';
import './styles.scss';

type ModalProps = {
	close?: () => void;
	variant?: string;
	className?: string;
	sizeWidth?: string;
	overModal?: boolean;
	children?: React.ReactNode;
	scroll?: boolean;
};

export const Modal = ({
	close,
	variant = '',
	className = '',
	sizeWidth = '',
	overModal = false,
	children,
	scroll = false,
}: ModalProps) => {
	const typeVariant = {
		fullscreen: 'is-fullscreen',
	};
	const isVariant = typeVariant[variant] || '';
	const styles = {
		width: sizeWidth,
		overflowY: (scroll === true
			? 'auto'
			: 'visible') as React.CSSProperties['overflowY'],
	};

	useEffect(() => {
		document.body.classList.add('fixed');
		return () => {
			if (!overModal) {
				document.body.classList.remove('fixed');
			}
		};
	}, [overModal]);

	return (
		<div
			className={setClass(`modal
        ${isVariant}
        ${className}`)}
		>
			<div className="modal__child" style={styles}>
				{close !== undefined && (
					<div className="modal__close" onClick={() => close()}>
						<Close size={24} />
					</div>
				)}
				{children}
			</div>
		</div>
	);
};
